<template>
    <div class="outer-wrapper">
    <div class="page-header clear-filter">
    </div>
    <div class="ls section form_position">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 text-lg-center">
                    <ul class="contact-list text-lg-left">
                        <li class="contact-list_address">B2, Vikas Chamber, D Block, Central Market, Prashant Vihar, Rohini, New Delhi – 110085</li>
                        <li class="contact-list_phone">+91- 80-10-342-342</li>
                        <li class="contact-work-time">7:00 A.M. - 7:00 P.M.</li>
                        <li class="contact-work-email">care@doodhvale.in</li>
                    </ul>
                    <h4 class="contact-social__title">Follow Us:</h4>
                    <ul class="contact-social">
                        <li>
                            <a href="https://www.facebook.com/doodhvale">
                                <i class="mdi-facebook-box"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://twitter.com/doodhvale">
                                <i class="cont__twitter"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.instagram.com/doodhvale/">
                                <i class="cont__instagram"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.youtube.com/channel/UCvxp2fZIUMX58W7nT1T5_wg">
                                <i class="cont__dribbble"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
export default {
    
}
</script>